import React from 'react';
import Layout from './../components/shared/Layout';
import Header from '../components/shared/Header';
import AboutSections from '../components/about/AboutSections';

const About = () => (
    <Layout title="About Us">
        <Header title="About Us" page="About" />
        <AboutSections />
    </Layout>
)

export default About;